import React, { useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import WebinarSignup from "../components/WebinarSignup";
import Accreditations from "../components/Accreditations";
import Countries from "../components/Countries";
import HowWeWork from "../components/HowWeWork";
import VideoReviews from "../components/VideoReviews";
import Consultations from "../components/Consultations";
import Services from "../components/Services";
import Universities from "../components/Universities";
import OfferLetters from "../components/OfferLetters";
import Partners from "../components/Partners";
import Media from "../components/Media";
import Team from "../components/Team";
import FAQ from "../components/FAQ";
import CTABand from "../components/CTABand";
import Footer from "../components/Footer";
import Webinars from "../components/Webinars";
import ApplicationDialog from "../components/ApplicationDialog";
import VideoDialog from "../components/VideoDialog";
import FloatingContact from "../components/FloatingContact";

const HomePage = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [videoOpen, setVideoOpen] = useState(false);
  const openForm = () => setFormOpen(true);
  const openVideo = () => setVideoOpen(true);

  return (
    <div className="min-h-screen" style={{ background: '#FAF8F5' }}>
      <Header onOpenForm={openForm} />
      <Hero onOpenForm={openForm} onPlayVideo={openVideo} />
      <WebinarSignup />
      <Accreditations />
      <Countries onOpenForm={openForm} />
      <VideoReviews />
      <Consultations onOpenForm={openForm} />
      <HowWeWork />
      <Services onOpenForm={openForm} />
      <Webinars />
      <Partners />
      <Universities onOpenForm={openForm} />
      <OfferLetters />
      <Team onOpenForm={openForm} showMembers={false} />
      <Media />
      <FAQ onOpenForm={openForm} />
      <CTABand onOpenForm={openForm} />
      <Footer />
      <FloatingContact onOpenForm={openForm} />
      <ApplicationDialog open={formOpen} onOpenChange={setFormOpen} />
      <VideoDialog open={videoOpen} onOpenChange={setVideoOpen} />
    </div>
  );
};

export default HomePage;
